/**
 * Map zoom → on-screen marker size so vessels grow when zooming in and shrink when zooming out.
 * Values are in CSS pixels (deck.gl screen-space).
 */

const clamp = (n, lo, hi) => Math.max(lo, Math.min(hi, n));

/**
 * @param {number} zoom - Map view zoom (e.g. deck.gl / Mapbox zoom level)
 * @returns {number} Icon width/height in pixels (square-ish icons)
 */
export function vesselIconPixelSizeForMapZoom(zoom) {
  const z = typeof zoom === 'number' && !Number.isNaN(zoom) ? zoom : 10;
  // Slightly larger defaults (~+25–35% vs prior) for readability at city/harbor zooms
  return Math.round(clamp(12 + (z - 7) * 2.85, 14, 68));
}

/**
 * @param {number} zoom
 * @returns {number} Scatterplot radius in pixels
 */
export function vesselDotRadiusPixelsForMapZoom(zoom) {
  const z = typeof zoom === 'number' && !Number.isNaN(zoom) ? zoom : 10;
  return clamp(5 + (z - 7) * 1.55, 6, 32);
}

/**
 * Threat / emphasis icons slightly larger than base friendly size (matches prior ~1.45 ratio).
 * @param {number} zoom
 * @returns {number}
 */
export function vesselThreatIconPixelSizeForMapZoom(zoom) {
  return Math.round(vesselIconPixelSizeForMapZoom(zoom) * 1.45);
}
